import ReactStrapTable from "components/reactStrapTable";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import ReactSelect from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import ViewHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import View from 'assets/icon/icon-icon-options-view-patient.svg';
import { cellRendererCheck, dateFormate } from "utils/columns";
import { OverlayTrigger } from "react-bootstrap";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import ErrorBoundary from "components/ErrorBoundary";
import Drawer from "components/Drawer";
import EditAccumulator from "components/EditAccumulator";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useAxios from "hooks/useAxios";
import { add } from "lodash";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
// import Loader from "components/Loader";
import useContextService from "hooks/useContextService";
import Loader from "components/Loader";
import ViewConfiguration from "components/ViewConfiguration";
import ViewAccumulator from "components/ViewAccumulator";
import { ModuleAccess } from "utils/moduleaccess";

let tableDataBackup = [];
let rowForEdit = {};
let updatedFields = {};
let addAccumulator = {};
let hasDatePopupOpen = false;
let checkhrsa = "N";
let checkNDC = "N";
let checkCrosswalkAuto = "N";
let checkpayor = "N";
let checkGPO = "N";
let Accumulator = [];
let initialStates = {
  currentPage: 1,
  pageSize: 100,
  order: "desc",
  orderBy: "modifiedDate",
  filters: [],
};
const AccumulatorTab = (props) => {
  
  const API = useAxios();
  const {
    manvalConfigedit,
    data,
    rowData,
    AccumulatorTable,
    accmulatorRecords,
    handelAccumulator,
    handelSort,
    onSearchColumnFilter,
    filter,
    manvalConfig,
    reset,
    toggleSider,
    collapseSider,
    selectedAccumulator,
    setSelectedAccumulator,
    setACCflag ,
    ACCflag,
    CEDid,
    setCElevelflag,
    configlevel,
CElevelflag,
resetFilterFlag,
                SetResetFilterFlag
  } = props;
  tableDataBackup = data;

  console.log(AccumulatorTable, 'AccumulatorTable');
  console.log(rowData, "RowDataAccumulatorTable");
  const [data2, setData1] = useState([]);
  const [tableData, setTableData] = useState(tableDataBackup);
  const [data1, setData] = useState(tableDataBackup);
  const [modal, setModal] = useState(false);

  const toggle = () => {
    if(viewaccumulator){
      setViewAccumulator(!viewaccumulator);
    }
  }
  const toggle1 = () => setEditAccumulator(!editaccumulator)
  const [check, setcheck] = useState(false);

  const [isCheckedsplitopti, setIsCheckedSplitOpti] = useState(false);
  const [editaccumulator, setEditAccumulator] = useState(false);
  const [viewaccumulator, setViewAccumulator] = useState(false);
  const [state, SetState] = useState([]);
  const [Selectedstate, SetSelectedState] = useState("");
  const [accumulatorname, setAccumulatorName] = useState("");
  const [contactperson, setContactPerson] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [phone, setPhone] = useState("");
  const [ext, setExt] = useState("");
  const [fax, setFax] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [tollfreeno, setTollfreeNo] = useState("");
  const [AccumulatorList, setAccumulatorlist] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isCheckedhrsa, setCheckedHRSA] = useState(false);
  const [isCheckedndc, setCheckedNDC] = useState(false);
  const [isCheckedcrosswalk, setCheckedCrosswalkAuto] = useState(false);
  const [isCheckedpayor, setCheckedPayor] = useState(false);
  const [isCheckedgpo, setCheckedGPO] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [accuData, setAccuData] = useState()
  //const [checkcarve, setCarve] = useState();
  useEffect(() => {
    // fetchAccumulator();
  }, []);

  const handleToggle = () => {
    setIsCheckedSplitOpti(!isCheckedsplitopti);
    //setIsChecked(isChecked === 'true' ? 'Y' : 'N')
  };
  const handleHRSA = () => {
    setCheckedHRSA(!isCheckedhrsa);
  };
  const handleNDCMap = () => {
    setCheckedNDC(!isCheckedndc);
    //setCheckedNDC(!isCheckedndc ? 'Y' : 'N');
  };
  const handleCrosswalkAuto = () => {
    setCheckedCrosswalkAuto(!isCheckedcrosswalk);
  };

  const handlePayor = () => {
    setCheckedPayor(!isCheckedpayor);
    //setCheckedPayor(prevState => prevState ? 'N' : 'Y');
  };

  const handleGPO = () => {
    setCheckedGPO(!isCheckedgpo);
  };


  const manvalaccumulatoredit = (rowData) => {
    // setRowData(rowData);
    setEditAccumulator(!editaccumulator);
    setAccuData(rowData)
  };
  const manvalaccumulatorView = (rowData) => {
    // setRowData(rowData);
    setViewAccumulator(!viewaccumulator);
    setAccuData(rowData)
  };
  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        {/* {renderEditButton(rowData)} */}
        {renderViewButton(rowData)}
      </div>
    );
  };
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
}
  // const renderEditButton = (rowData) => {
  //   if (hasPermission('ED'))
  //   return (
  //     <Button
  //       className="text-primary p-0 text-decoration-none"
  //       color="link"
  //       onClick={() => manvalaccumulatoredit(rowData)}
  //       title="Edit Accumulator"
  //     >
  //       <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
  //     </Button>
  //   );
  // };
  const renderViewButton = (rowData) => {
     if (hasPermission('VW'))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        // onClick={() => manvalaccumulatorView(rowData)}
        onClick={()=>{manvalConfig(rowData),handelAccumulatorflag()}}
        title="View Accumulator"
      >
        <HoverImage src={View} hoverSrc={ViewHover} alt="" />
      </Button>
    );
  };
  const handelAccumulatorflag=()=>{
    setACCflag(true)
    if(configlevel==true){
      setCElevelflag(true)
    }
  }
  const editRow = (rowData, isEdit = true) => {
    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    // setTouched('');
    // setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setData(tempData);
  };
  const savePanelUpdateRow = async () => {
    console.log("krishna");
  };

  const renderEditLButton1 = (rowData) => {
     if (hasPermission('ED'))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => editRow(rowData)}
        title="Edit"
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
  };



  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  let addDisabled =
    addAccumulator?.accumulatorname != null &&
      addAccumulator?.contactperson != null &&
      addAccumulator?.address1 != null &&
      addAccumulator?.address2 != null &&
      addAccumulator?.address2 != null &&
      addAccumulator?.city != null &&
      addAccumulator?.Selectedstate != null &&
      addAccumulator?.zipcode != null &&
      addAccumulator?.phone != null &&
      addAccumulator?.ext != null &&
      addAccumulator?.fax != null &&
      addAccumulator?.email != null &&
      addAccumulator?.website != null &&
      addAccumulator?.tollfreeno != null
      ? false
      : true;

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ceName",
      text: "Accumulator Name",
      sort: false,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ceName),
    },
    {
      dataField: "opaCode",
      text: "OPA ID",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      // cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.opaCode),

    },
     {
      dataField: "liveDate",
      text: "Live Date",
       sort: false,
      width: 200,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.cEliveDate),
    },
    {
      dataField: "address1",
      text: "Address 1",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.address1),
    },
    {
      dataField: "address2",
      text: "Address 2",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.address2),
    },
    {
      dataField: "stateName",
      text: "State",
       sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.stateName),
    },
    {
      dataField: "cityName",
      text: "City",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.cityName),
    },
    {
      dataField: "zipCode",
      text: "Zip Code",
  sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.zipCode),
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.phone),
    },
    {
      dataField: "contactPerson",
      text: "Contact Person",
     sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.contactPerson),
    },
  ];
  const handelState = async () => {
    try {
      const { data } = await API.get("SBConfig/TypeStatus/states", {
        hasDefaultURL: true,
      });
      //console.log(data, "data")

      if (data) {
        SetState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handelState();
  }, []);
  const handelStateChange = (e) => {
    const { value } = e.target;

    SetSelectedState(value);
    addAccumulator.Selectedstate = value;
  };
  const handleAccumulatorName = ({ target: { value } }) => {
    setAccumulatorName(value);
    addAccumulator.accumulatorname = value;
  };
  const handleContactPerson = ({ target: { value } }) => {
    setContactPerson(value);
    addAccumulator.contactperson = value;
  };
  const handleAddress1 = ({ target: { value } }) => {
    setAddress1(value);
    addAccumulator.address1 = value;
  };

  const handleAddress2 = ({ target: { value } }) => {
    setAddress2(value);
    addAccumulator.address2 = value;
  };

  const handleCity = ({ target: { value } }) => {
    setCity(value);
    addAccumulator.city = value;
  };
  const handleZipCode = ({ target: { value } }) => {
    setZipcode(value);
    addAccumulator.zipcode = value;
  };

  const handlePhone = ({ target: { value } }) => {
    setPhone(value);
    addAccumulator.phone = value;
  };

  const handleExt = ({ target: { value } }) => {
    setExt(value);
    addAccumulator.ext = value;
  };

  const handleFax = ({ target: { value } }) => {
    setFax(value);
    addAccumulator.fax = value;
  };

  const handleEmail = ({ target: { value } }) => {
    setEmail(value);
    setcheck(true);
    addAccumulator.email = value;
  };

  const handleWebsite = ({ target: { value } }) => {
    setWebsite(value);
    addAccumulator.website = value;
  };

  const handleTollfreeNo = ({ target: { value } }) => {
    setTollfreeNo(value);
    addAccumulator.tollfreeno = value;
  };
  const handleSubmit = async () => {
    var list = {};

    let checkSplit = "N";
    if (isCheckedsplitopti == true) {
      checkSplit = "Y";
    }
    if (isCheckedhrsa == true) {
      checkhrsa = "Y";
    }
    if (isCheckedgpo == true) {
      checkGPO = "Y";
    }
    if (isCheckedndc == true) {
      checkNDC = "Y";
    }
    if (isCheckedcrosswalk == true) {
      checkCrosswalkAuto = "Y";
    }
    if (isCheckedpayor == true) {
      checkpayor = "Y";
    }

    list.CEName = accumulatorname;
    list.LowestPriceCheckFlag = checkSplit;
    list.CarveInFlag = checkhrsa;
    list.GPOProhibitionFlag = checkGPO;
    list.NDCAsCDMFlag = checkNDC;
    list.OPACode = rowData.opaCode;
    list.CoveredEntityID = rowData.coveredEntityID;
    list.CoveredEntityTypeID = rowData.coveredEntityTypeID;
    list.ChargeAutomappingFlag = checkCrosswalkAuto;
    list.PayorExclusionFlag = checkpayor;
    list.ContactName = contactperson;
    list.Address1 = address1;
    list.Address2 = address2;
    list.CityName = city;
    list.StateID = Selectedstate;
    list.ZipCode = zipcode;
    list.Phone = phone;
    list.Ext = ext;
    list.Fax = fax;
    list.EmailID = email;
    list.Website = website;
    list.TollFreeNo = tollfreeno;

    setLoading(true);

    console.log(list, "lissstst")
    let payload = [];
    payload.AccumulatorEntityList = list;
    let AccumulatorEntityList = [payload.AccumulatorEntityList];
    try {
      const { result } = await API.post(
        `SBConfig/CoveredEntity/AddAccumulator`,
        { AccumulatorEntityList },
        {
          hasDefaultURL: true,
        }
      );

      //  );
      if (result) {
        toast.success("Accumulation saved successfully");
        setResultData(result.data);
        console.log(result, "postdata");
        //setHideRow(true);
        //setShowResultRow(false);

        fetchAccumulator();
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    // setLoading(false);
    toggle();
    fetchAccumulator();
  };

  const handleReset = () => {
    debugger
    addAccumulator = {};
    Accumulator = [];
    // resetForm();
    setAccumulatorName("");
    setIsCheckedSplitOpti(false);
    setCheckedHRSA(false);
    setCheckedGPO(false);
    setCheckedNDC(false);
    setCheckedCrosswalkAuto(false);
    setCheckedPayor(false);
    setContactPerson("");
    setAddress1("");
    setAddress2("");
    setCity("");
    SetState([]);
    setZipcode("");
    setPhone("");
    setExt("");
    setFax("");
    setEmail("");
    setWebsite("");
    setTollfreeNo("");
  };

  const fetchAccumulator = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBConfig/CoveredEntityC/accumulationlist/${CEDid}`,
        initialStates,
        {
          hasDefaultURL: true,
        }
      );
      console.log(data, "acclistaaa");
      // if (data) {
      //     setData1(data.data);
      setLoading(true);
      // }
      // else {
      //     setData([]);
      // }
    } catch (error) {
      //. console.log(error.Message);
    }
  };
  const handleFilterCancel = () => {
    handelAccumulator();
    // refetch();
  };
  return (
    <div>
      <div>
        {/* <Formik
          // initialValues={initialValues}
          // onSubmit={handleSubmit}
          // validationSchema={validationSchema}
          // enableReinitialize={true}
          children={(props) => {
            // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
            return (
              <div hidden={""}>
                <Row sm={5} style={{ justifyContent: "flex-end" }}>
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                  </Col>
                </Row>
              </div>
            );
          }}
        ></Formik> */}
        {/* {loading && <Loader opacity={0.02} color="black" />} */}
        <div
          className="table-card scroll-table position-relative border-0 rounded pt-2"
          fixed-height={data2.length > 0 ? "fixed-height" : "default"}
        >
           <h5 className="f-16 text-primary font-weight-700">
            Accumulators Count ({AccumulatorTable?AccumulatorTable?.length:0})
            </h5>
            <hr/>
          <ReactStrapTable
            id="Accumulator-table"
            height={550}
            fixedColumn
            width={1200}
            display
            hidefilter={true}
            //reset={reset}
            data={AccumulatorTable}
            columns={mainCol}
            //onExport={onExport}
            filters={filter}
            totalRecords={accmulatorRecords}
            pageSize={filter.pageSize}
            currentPage={filter.currentPage}
            handleSort={handelSort}
            // onPageChange={onHandlePageChange}
            // onPageSizeChange={onPageSizeChange}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={onSearchColumnFilter}
            toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  resetFilterFlag = {resetFilterFlag}
                SetResetFilterFlag= {SetResetFilterFlag}
                  // showtoggle={true}
          // hasExportPermission={hasExportPermission}
          />
        </div>
      </div>
      {/* <Drawer
        direction="end"
        isOpen={editaccumulator}
        toggle={toggle1}
        size="lg"
        title="Edit Accumulator"
      >
        <EditAccumulator accuData={accuData} toggle1={toggle1} toggle={toggle} handelAccumulator={handelAccumulator} filter={filter} />
      </Drawer> */}

      <Drawer
        direction="end"
        isOpen={viewaccumulator}
        toggle={toggle}
        size="lg"
        title="View Accumulator"
      >
        <ViewAccumulator toggle={toggle} toggle1={toggle1} accuData={accuData} />
      </Drawer>

      <Modal
        isOpen={modal}
        fade={false}
        toggle={toggle}
        className={props.className}
      >
        <ModalHeader toggle={toggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            Add Accumulator
          </h5>
        </ModalHeader>

        <ModalBody>
          <Formik
            // initialValues={initialValues}
            //onSubmit={handleSubmit}
            // validationSchema={validationSchema}
            // enableReinitialize={true}
            children={(props) => {
              const {
                isSubmitting,
                handleSubmit,
                resetForm,
                setFieldValue,
                errors,
                touched,
              } = props;
              return (
                <div hidden={""}>
                  <Row sm={5}>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="accumulatorname">Accumulator Name</Label>
                        <Input
                          id="accumulatorname"
                          name="accumulatorname"
                          type="text"
                          placeholder="Enter Accumulator Name"
                          autoComplete="off"
                          value={accumulatorname}
                          onChange={handleAccumulatorName}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label>Split Optimizer</Label>
                        <div className="d-flex">
                          <label className="toggle-label">
                            <input
                              type="checkbox"
                              id="hrsamedicaid"
                              //checked={isChecked ? "N" : "Y"}
                              checked={isCheckedsplitopti}
                              onChange={handleToggle}
                            />
                            <span className="back">
                              <span className="toggle"></span>
                              <span className="label on">Yes</span>
                              <span className="label off">No</span>
                            </span>
                          </label>
                          <div
                            className="help-tip"
                            id="UncontrolledTooltipExample"
                            style={{
                              // top:"4px",
                              // right:"45px",
                              textAlign: "center",
                              backgroundColor: "#63aecf",
                              borderRadius: "8px",
                              width: "20px",
                              height: "20px",
                              fontSize: "14px",
                              lineHeight: "20px",
                              cursor: "default",
                              marginTop: "11px",
                              marginLeft: "10px",

                              color: "white",
                            }}
                          >
                            ?
                            <UncontrolledTooltip
                              placement="right"
                              target="UncontrolledTooltipExample"
                              style={{
                                color: "black",
                                backgroundColor: "white",
                              }}
                            >
                              <p>
                                <strong>Hospital Name:</strong>
                                <br />
                                Informational purposes only. Hospital Name must
                                be unique per Wholesaler and a max of 100
                                characters.
                              </p>
                            </UncontrolledTooltip>
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>HRSA Medicaid Billing</Label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                id="hrsamedicaid"
                                checked={isCheckedhrsa}
                                onChange={handleHRSA}
                              />
                              <span className="back">
                                <span className="toggle"></span>
                                <span className="label on">Carve-In</span>
                                <span className="label off">Carve-Out</span>
                              </span>
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>GPO Prohibition </Label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                id="hrsamedicaid"
                                checked={isCheckedgpo}
                                onChange={handleGPO}
                              />
                              <span className="back">
                                <span className="toggle"></span>
                                <span className="label on">Yes</span>
                                <span className="label off">No</span>
                              </span>
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label> NDC to NDC Map</Label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                id="ndcmap"
                                checked={isCheckedndc}
                                onChange={handleNDCMap}
                              />
                              <span className="back">
                                <span className="toggle"></span>
                                <span className="label on">Yes</span>
                                <span className="label off">No</span>
                              </span>
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>Crosswalk-NDC Automapping</Label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                id="ndcmap"
                                checked={isCheckedcrosswalk}
                                onChange={handleCrosswalkAuto}
                              />
                              <span className="back">
                                <span className="toggle"></span>
                                <span className="label on">Yes</span>
                                <span className="label off">No</span>
                              </span>
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>
                              Payor Exclusions (Includes Out of State Medicaid)
                            </Label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                id="ndcmap"
                                checked={isCheckedpayor}
                                onChange={handlePayor}
                              />
                              <span className="back">
                                <span className="toggle"></span>
                                <span className="label on">Yes</span>
                                <span className="label off">No</span>
                              </span>
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <h5 className="f-15 text-primary font-weight-700 mt-2">
                    Address Informat
                  </h5>
                  <Row sm={5}>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Contactperson">Contact Person</Label>
                        <Input
                          id="Contactperson"
                          name="Contactperson"
                          className="required"
                          type="text"
                          placeholder="Enter Contact Person Name"
                          autoComplete="off"
                          value={contactperson}
                          onChange={handleContactPerson}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Address1">Address 1</Label>
                        <Input
                          id="Address1"
                          name="Address1"
                          type="text"
                          placeholder="Enter Address"
                          autoComplete="off"
                          value={address1}
                          onChange={handleAddress1}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Address1">Address 2</Label>
                        <Input
                          id="Address"
                          name="Address"
                          type="text"
                          placeholder="Enter Address"
                          autoComplete="off"
                          value={address2}
                          onChange={handleAddress2}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="City">City</Label>
                        <Input
                          id="City"
                          name="City"
                          type="text"
                          placeholder="Enter City"
                          autoComplete="off"
                          value={city}
                          onChange={handleCity}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="state">State</Label>
                        <Field
                          id="state"
                          name="state"
                          type="select"
                          placeholder="Select State "
                          autoComplete="off"
                          options={state}
                          value={Selectedstate}
                          component={FormikSelectField}
                          defaultoption="--Select--"
                          keys={{
                            id: "stateID",
                            label: "stateName",
                          }}
                          onChange={(e, ptype) => handelStateChange(e)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Zip Code">Zip Code</Label>
                        <Input
                          id="zipcode"
                          name="zipcode"
                          type="text"
                          placeholder="Enter Zip Code "
                          autoComplete="off"
                          value={zipcode}
                          onChange={handleZipCode}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="phoneno">Phone</Label>
                        <Input
                          id="phoneno"
                          name="phoneno"
                          type="text"
                          placeholder="Enter Phone "
                          autoComplete="off"
                          value={phone}
                          onChange={handlePhone}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="ext">Ext</Label>
                        <Input
                          id="ext"
                          name="ext"
                          type="text"
                          placeholder="Enter Ext "
                          autoComplete="off"
                          value={ext}
                          onChange={handleExt}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="fax">Fax</Label>
                        <Input
                          id="fax"
                          name="fax"
                          type="text"
                          placeholder="Enter Fax No "
                          autoComplete="off"
                          value={fax}
                          onChange={handleFax}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Email">Email</Label>
                        <Input
                          id="Email"
                          name="Email"
                          type="text"
                          placeholder="Enter Email Id "
                          autoComplete="off"
                          value={email}
                          onChange={handleEmail}
                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Website">Website</Label>
                        <Input
                          id="website"
                          name="website"
                          type="text"
                          placeholder="Enter Website"
                          autoComplete="off"
                          value={website}
                          onChange={handleWebsite}
                          component={""}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Toll Free No">Toll Free No</Label>
                        <Input
                          id="Tollno"
                          name="Tollno"
                          type="text"
                          placeholder="Enter Toll Free No"
                          autoComplete="off"
                          value={tollfreeno}
                          onChange={handleTollfreeNo}
                          component={""}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              );
            }}
          ></Formik>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit} disabled={addDisabled}>
            Save
          </Button>{" "}
          <Button color="primary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

    </div>
  );
};

export default AccumulatorTab;
